export const SET_ZOOM = 'SET_ZOOM'
export const SET_CENTER = 'SET_CENTER'
export const SET_BOUNDS = 'SET_BOUNDS'
export const SET_CARD = 'SET_CARD'
export const RESET_ZOOM = 'RESET_ZOOM'
